// PROP_TYPES - Available prop types for scatter/stamp tools

export interface PropType {
  slug: string;
  name: string;
  icon: string; // Sprite icon name (prop-* for unique, layer-* for shared)
  hidden?: boolean;
  defaultSize: number; // theme default size at zoom 14
}

export const PROP_TYPES: PropType[] = [
  // Decorative (scatter/stamp only)
  { slug: "tree", name: "Tree", icon: "prop-tree", defaultSize: 0.55 },
  { slug: "tree-palm", name: "Palm Tree", icon: "prop-palm", defaultSize: 0.55 },
  { slug: "tree-pine", name: "Pine Tree", icon: "prop-pine", defaultSize: 0.55 },
  { slug: "bush", name: "Bush", icon: "prop-bush", defaultSize: 0.45 },
  { slug: "rock", name: "Rock", icon: "prop-rock", defaultSize: 0.4 },

  // Hidden — still render on map, just not placeable via stamp/scatter UI
  { slug: "lamp", name: "Lamp Post", icon: "prop-lamp", defaultSize: 0.35 },
];

export const VISIBLE_PROP_TYPES = PROP_TYPES.filter((p) => !p.hidden);

export type PropTypeSlug = (typeof PROP_TYPES)[number]["slug"];
